import styled from "styled-components";
import IUMRSNavBar from "../iumrs-icam25/IUMRSNavbar";
import { ICAMNavroute } from "../../../utils/ICAMnavroute";
import { MapPin, Calendar } from "lucide-react";
import Navbar from "../../Navbar";
import FooterSection from "../../FooterSection";
import { jun2026WorkshopSections } from "../../../utils/jun2026workshopsection";
import WorkshopHero from "./WorkshopHero";
import WorkshopPageContent from "./WorkshopPageContent";
import heroImage1 from "../../../assets/images/workshop2026/workshop_banner2026.jpg"
import heroImage2 from '../../../assets/images/workshop2026/workshop_photo2.jpg'
import heroImage3 from '../../../assets/images/workshop2026/workshop_photo3.jpg'
import heroImage4 from '../../../assets/images/workshop2026/workshop_photo4.jpg'


const JunWorkshop2026 = () => {

    const slideShow = [heroImage1, heroImage2, heroImage3, heroImage4]

    return(
        <Container>
            <Navbar />
            <WorkshopHero 
                images={slideShow}
                titleLines={["Computational", "Materials Modelling"]}
                accentLine="& Simulation Workshop"
                meta={[
                    { icon: Calendar, label: "4 – 6 June 2026" },
                    { icon: MapPin, label: "Toyota Ghana – UG Engineering Centre, Legon" },
                ]}
                primaryCta={{ label: "Register Now", to: "/amrs-jun-2026-workshop/register" }}
                secondaryCta={{
                    label: "Verify transaction",
                    onClick: () => window.location.href = "/event/payment-verification",
                }}/>
            <WorkshopPageContent sections={jun2026WorkshopSections} />
            <FooterSection />

        </Container>
    )
}

const Container = styled.div`
    background : 'blue';
    height : 120vh;
`
export default JunWorkshop2026

